import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Date picker modal for the "cars inside area" playback.
@Component({
  selector: 'area-move-modal',
  templateUrl: './area-move-modal.component.html',
})
export class AreaMoveModalComponent {
  @Input() form: FormGroup;
}
